export const COUNTRIES = [
  { name: "Afghanistan", code: "AF" },
  { name: "Australia", code: "AU" },
  { name: "Bangladesh", code: "BD" },
  { name: "England", code: "GB-ENG" }, // GB is typically used, or GB-ENG if supported, but standard ISO is GB for UK. specific flags might need handling if flag-icons splits them. flag-icons has 'gb-eng' usually.
  { name: "India", code: "IN" },
  { name: "Ireland", code: "IE" },
  { name: "New Zealand", code: "NZ" },
  { name: "Pakistan", code: "PK" },
  { name: "South Africa", code: "ZA" },
  { name: "Sri Lanka", code: "LK" },
  { name: "West Indies", code: "WI" }, // Not a country, but a cricketing entity. flag-icons usually has 'un' or special. But ISO 'WI' is not standard country. However, user example showed "iso_code": "WI". So I will add it.
  { name: "Zimbabwe", code: "ZW" },
  { name: "Nepal", code: "NP" },
  { name: "United States", code: "US" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "Canada", code: "CA" },
  { name: "Netherlands", code: "NL" },
  { name: "Scotland", code: "GB-SCT" }, // flag-icons often supports gb-sct
  { name: "Namibia", code: "NA" },
  { name: "Oman", code: "OM" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Uganda", code: "UG" },
];
